import ProdModel from '@/models/Prod';
import OrderModel from "@/models/Order";
import VisaModel from "@/models/Visa";
import PromModel from "@/models/Prom";

const CLEAR_PROD_DETAIL_INFO = 'CLEAR_PROD_DETAIL_INFO';
const GET_PROD_DETAIL = 'GET_PROD_DETAIL';
const SET_CALENDAR_MONTH_TEXT = 'SET_CALENDAR_MONTH_TEXT';
const GET_PROD_STOCK_PRICE = 'GET_PROD_STOCK_PRICE';
const UPDATE_SELECTED_INFO = 'UPDATE_SELECTED_INFO';
const CONFIRM_SELECTED_INFO = 'CONFIRM_SELECTED_INFO';
const SEND_VISA_EMAIL = 'SEND_VISA_EMAIL';
const GET_COUPON_LIST_BY_SPU_NO = 'GET_COUPON_LIST_BY_SPU_NO';
const PICK_COUPON_BY_SPU_NO = 'PICK_COUPON_BY_SPU_NO';
const UPDATE_COLLECT_PROD = 'UPDATE_COLLECT_PROD';
const GET_COMPANY_SPU_CONTACT_HOT = 'GET_COMPANY_SPU_CONTACT_HOT';
const GET_SKU_STOCK_PRICE_MONTH_LIST = 'GET_SKU_STOCK_PRICE_MONTH_LIST';
const GET_PROD_STOCK_PRICE_LIST = 'GET_PROD_STOCK_PRICE_LIST';
const GET_BARRAGE_BY_SPUNO = 'GET_BARRAGE_BY_SPUNO';
const GET_STOCK_PRICE_BY_ONE_DAY = 'GET_STOCK_PRICE_BY_ONE_DAY';

/**
 * 清除商品详情数据
 */
async function clearProdDetailInfo() {
  return {
    type: CLEAR_PROD_DETAIL_INFO
  }
}

/**
 * 获取产品详情
 * @param {string} spuNo 内部自动生成的产品编码
 */
async function getProdDetail(spuNo, uuid) {
  const payload = await new ProdModel().productDetail(spuNo, uuid);
  return {
    type: GET_PROD_DETAIL,
    payload
  }
}

/**
 * 设置展示的日历
 * @param {string} monthText 日历(年-月)
 */
function setCalendarMonthText(monthText) {
  return {
    type: SET_CALENDAR_MONTH_TEXT,
    payload: monthText
  }
}

/**
 * 获取产品库价信息
 * @param {string} skuNo
 * @param {string} day 日历(年-月)
 */
async function getProdStockPrice(skuNo, day) {
  const payload = await new ProdModel().stockPrice(skuNo, day);
  return {
    type: GET_PROD_STOCK_PRICE,
    payload
  }
}

/**
 * 获取产品库价信息
 * @param {string} skuNo
 * @param {string} day 日历(年-月)
 */
async function getProdStockPriceList(skuNo, day) {
  const payload = await new ProdModel().stockPriceList(skuNo, day);
  return {
    type: GET_PROD_STOCK_PRICE_LIST,
    payload
  }
}

/**
 * 获取产品库价信息- 携宠游
 * @param {string} skuNo
 * @param {string} day 日历(年-月-日)
 */
async function getStockPriceByOneDay(skuNo, day) {
  const payload = await new ProdModel().stockPriceByOneDay(skuNo, day);
  return {
    type: GET_STOCK_PRICE_BY_ONE_DAY,
    payload
  }
}

/**
 * 更新选中套餐信息
 * @param {Object} selectedInfo 选中套餐信息
 */
async function updateSelectedInfo(selectedInfo) {
  return {
    type: UPDATE_SELECTED_INFO,
    payload: selectedInfo
  }
}

/**
 * 购买前确认订单信息
 * @param {Object} selectedInfo 选中套餐信息
 */
async function confirmSelectedInfo(selectedInfo) {
  const payload = await new OrderModel().checkTrade(selectedInfo);
  return {
    type: CONFIRM_SELECTED_INFO,
    payload
  }
}

/**
 * 发送签证邮件
 */
async function sendVisaEmail(params) {
  const payload = await new VisaModel().sendVisaEmail(params);
  return {
    type: SEND_VISA_EMAIL,
    payload
  }
}

/**
 * 获取商品适用优惠券
 */
async function getCouponListBySpuNo(spuNo) {
  const payload = await new PromModel().couponListBySpuNo(spuNo);
  return {
    type: GET_COUPON_LIST_BY_SPU_NO,
    payload
  }
}

/**
 * 领取商品适用优惠券
 */
async function pickCouponBySpuNo(params) {
  const payload = await new PromModel().pickCoupon(params);
  return {
    type: PICK_COUPON_BY_SPU_NO,
    payload
  }
}

/**
 * 更改商品收藏信息
 * @param {string} spuNo 内部自动生成的产品编码
 */
async function updateCollectProd(spuNo) {
  const payload = await new ProdModel().updateCollectProd(spuNo);
  return {
    type: UPDATE_COLLECT_PROD,
    payload
  }
}

/**
 * 增加分销商产品咨询入口访问量
 */
async function getCompanySpuContactHot(params) {
  const payload = await new ProdModel().getCompanySpuContactHot(params);
  return {
    type: GET_COMPANY_SPU_CONTACT_HOT,
    payload
  }
}

/**
 * 获取商品sku全部可售卖月份
 */
async function getSkuStockPriceMonthList(params) {
  const payload = await new ProdModel().getSkuStockPriceMonthList(params);
  return {
    type: GET_SKU_STOCK_PRICE_MONTH_LIST,
    payload
  }
}

/**
 * 产品购买数量显示
 */
async function getBarrageBySpuNo(params) {
  const payload = await new ProdModel().getBarrageBySpuNo(params);
  return {
    type: GET_BARRAGE_BY_SPUNO,
    payload
  }
}

const ACTION_TYPES = {
  CLEAR_PROD_DETAIL_INFO,
  GET_PROD_DETAIL,
  SET_CALENDAR_MONTH_TEXT,
  GET_PROD_STOCK_PRICE,
  UPDATE_SELECTED_INFO,
  CONFIRM_SELECTED_INFO,
  SEND_VISA_EMAIL,
  GET_COUPON_LIST_BY_SPU_NO,
  PICK_COUPON_BY_SPU_NO,
  UPDATE_COLLECT_PROD,
  GET_COMPANY_SPU_CONTACT_HOT,
  GET_SKU_STOCK_PRICE_MONTH_LIST,
  GET_PROD_STOCK_PRICE_LIST,
  GET_BARRAGE_BY_SPUNO,
  GET_STOCK_PRICE_BY_ONE_DAY
};

const ACTION = {
  clearProdDetailInfo,
  getProdDetail,
  setCalendarMonthText,
  getProdStockPrice,
  updateSelectedInfo,
  confirmSelectedInfo,
  sendVisaEmail,
  getCouponListBySpuNo,
  pickCouponBySpuNo,
  updateCollectProd,
  getCompanySpuContactHot,
  getSkuStockPriceMonthList,
  getProdStockPriceList,
  getBarrageBySpuNo,
  getStockPriceByOneDay
};

const ProdDetail = {
  ACTION_TYPES,
  ACTION
}

export default ProdDetail;